var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoulettePointer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1088 1076",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,41)",
    d: "m0 0h47l26 2 32 5 27 6 27 8 28 10 29 13 20 10 24 14 23 15 15 11 14 11 15 14 12 11 7 7 7 8 14 17 15 20 14 20 15 24 12 22 8 16 9 20 10 27 9 29 6 27 5 33 2 25v41l-3 33-5 30-7 32-11 36-9 25-12 28-13 26-9 15-11 17-12 16-10 13-12 13-7 8-16 16-11 9-9 8-12 9-19 13-15 9-18 10-16 8-29 13-46 18-42 15-36 12-32 10-50 14-39 10-37 9-56 12-52 10-60 9-101 17-122 19-29 4h-11l-13-4-8-6-6-7-5-10-2-9v-21l3-22 2-19 8-56 9-58 8-46 12-67 6-40 10-48 12-52 14-56 19-67 9-30 12-36 14-41 16-41 13-30 9-19 13-23 15-24 14-19 14-17 11-12 5-6h2l2-4h2l2-4h2v-2l8-7 15-13 18-14 24-16 21-12 23-12 29-12 33-11 32-8 38-7 28-3z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulettePointer);
export default __webpack_public_path__ + "static/media/roulette-pointer.951eb5207f7793d30b4c5948f57a91f8.svg";
export { ForwardRef as ReactComponent };